import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { BuyTicketInput, CreateEventInput, EventListQuery, EventInterestView, SetEventInterestInput, EventView, TicketOrderView, } from '../../event.js';
export const eventRoutes = {
    create: { method: 'POST', path: '/events', body: CreateEventInput, response: EventView },
    list: { method: 'GET', path: '/events', query: EventListQuery, response: Paginated(EventView) },
    get: { method: 'GET', path: '/events/:eventId', response: EventView },
    buy: {
        method: 'POST',
        path: '/events/:eventId/tickets',
        body: BuyTicketInput,
        response: TicketOrderView,
    },
    interest: {
        method: 'PUT',
        path: '/events/:eventId/interest',
        body: SetEventInterestInput,
        response: EventInterestView,
    },
    myTickets: {
        method: 'GET',
        path: '/me/tickets',
        query: CursorQuery,
        response: Paginated(TicketOrderView),
    },
    /** Host cancels the event: all confirmed orders refunded (FR-ADM-54 host-side). */
    cancel: {
        method: 'DELETE',
        path: '/events/:eventId',
        response: z.object({ id: z.string(), refundedOrders: z.number().int() }),
    },
};
//# sourceMappingURL=routes.js.map